import authenticationService from '../services/authentication/AuthenticationService';
import notificationService from '../services/notification/NotificationService';
import enrollmentService from '../services/enrollment';
import {captureError} from '../utils/log';

import {
  REQUEST_NOTIFICATIONS,
  RECEIVE_NOTIFICATIONS,
  HIDE_NOTIFICATION,
  REMOVE_NOTIFICATION,
  REMOVE_SUGGESTION,
  UPDATE_LAST_SEEN_NOTIFICATION,
  VIEWED_NOTIFICATION
} from './constant';

const NOTIFICATION_REMOVE_TIMEOUT = 500;

function requestNotifications() {
  return {
    type: REQUEST_NOTIFICATIONS
  };
}

function receiveNotifications(notifications, organisationId) {
  return {
    type: RECEIVE_NOTIFICATIONS,
    notifications,
    organisationId
  };
}

export function hideNotification(notificationId) {
  return {
    type: HIDE_NOTIFICATION,
    notificationId
  };
}

export function removeNotification(notificationId) {
  return {
    type: REMOVE_NOTIFICATION,
    notificationId
  };
}

export function removeSuggestion(invitationId) {
  return {
    type: REMOVE_SUGGESTION,
    payload: {invitationId}
  };
}

export function fetchSuggestions(organisationId) {
  const canSeeSuggestions = authenticationService.roles().isManager() || authenticationService.roles().isInviting();

  if (!canSeeSuggestions) {
    return Promise.resolve([]);
  }

  return enrollmentService.network.getSuggestions(organisationId)
    .then(suggestions => suggestions)
    .catch(() => []);
}

export function fetchNotifications(organisation) {
  return dispatch => {
    dispatch(requestNotifications());

    return Promise.all([
      notificationService.getNewInformationNotifications(organisation),
      notificationService.getNewActionsNotifications(organisation),
      fetchSuggestions(organisation.organisationId)
    ])
      .then(([informationNotifications, notificationsWithActions, suggestions]) => {
        dispatch(receiveNotifications(
          {
            informationNotifications,
            notificationsWithActions,
            suggestions
          },
          organisation.organisationId
        ));
      })
      .catch(error => {
        captureError('[actions/notifications/fetchNotifications] notificationService.getNewInformationNotifications | notificationService.getNewActionsNotifications | enrollmentService.network.getSuggestions', error);
        throw new Error(error);
      });
  };
}

export function dismissNotification(notificationId) {
  return dispatch => {
    dispatch(hideNotification(notificationId));

    setTimeout(() => {
      dispatch(removeNotification(notificationId));
    }, NOTIFICATION_REMOVE_TIMEOUT);
  };
}

export function setNotificationViewed(notificationId) {
  return {
    type: VIEWED_NOTIFICATION,
    notificationId
  };
}

export function updateLastSeenNotifications(organisationId) {
  return dispatch => {
    notificationService.updateLastSeenNotifications(organisationId)
      .then(() => dispatch({type: UPDATE_LAST_SEEN_NOTIFICATION}))
      .catch(error => {
        captureError('enrollmentService.network.updateLastSeenNotifications', error);
        throw new Error(error);
      });
  };
}

export function acceptSuggestion(invitationId) {
  return (dispatch, getState) => {
    const {organisationId} = getState().organisation;
    return enrollmentService.network.acceptSuggestion(organisationId, invitationId)
      .then(() => dispatch(removeSuggestion(invitationId)))
      .catch(error => {
        captureError('enrollmentService.network.acceptSuggestion', error);
        throw new Error(error);
      });
  };
}

export function rejectSuggestion(invitationId, rejectionReason) {
  return (dispatch, getState) => {
    const {organisationId} = getState().organisation;
    return enrollmentService.network.rejectSuggestion(organisationId, invitationId, rejectionReason)
      .then(() => dispatch(removeSuggestion(invitationId)))
      .catch(error => {
        captureError('enrollmentService.network.rejectSuggestion', error);
        throw new Error(error);
      });
  };
}
